import React, { useState, useEffect } from 'react';
import { Row, Col, Input, Tag, Checkbox, Button, Card } from 'antd';
import { remove } from 'lodash'
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { API } from 'aws-amplify';
import FiltersTable from '../../FiltersTable/index.jsx';
import {usePagination} from '../../../../hooks/useFiltersPagination.js';


const { Search } = Input;

const UserProfile = (
  {
    tipoSuscripcion,
    setTipoSuscripcion,
    mercado,   
    setMercado
  }
) => {
  const [selectedData1, setSelectedData1] = useState();
  const [selectedData2, setSelectedData2] = useState();
  const [searchValue1, setSearchValue1] = useState();
  const [searchValue2, setSearchValue2] = useState();
  const [showLoadingData1, setShowLoadingData1] = useState(false);
  const [showLoadingData2, setShowLoadingData2] = useState(false);
  const [selectedsData1, setSelectedsData1] = useState([]);
  const [selectedsData2, setSelectedsData2] = useState([]);
  const [banderaTags1, setBanderaTags1] = useState(false)
  const [banderaTags2, setBanderaTags2] = useState(false)

  const [selectTipoSubs, setSelectTipoSubs] = useState(false);
  const [selectMercado, setSelectMercado] = useState(false);

  const fetchFilter1 = async (filter = null) => {
    try {
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { query: "getSubscription", name_filter: "${filter}" }) {
            key
            description_filter
            type_filter
            value_filter
            id_statement
          }
        }`
      });
  
      const data = response.data.getFiltersRedshift.sort((a, b) => a.value_filter.localeCompare(b.value_filter));
  
      if (data[0].id_statement !== null) {
        await getValues({
          idStatement: data[0].id_statement,
          query: "getSubscription",
          setter: setSelectedData1,
          showLoading: setShowLoadingData1
        });
      } else {
        const newData = data.map(item => {
          const { id_statement, ...rest } = item;
          return rest;
        });
  
        setSelectedData1(newData.length > 0 && newData[0].value_filter !== "Sin Datos" ? newData : []);
        setShowLoadingData1(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle the error appropriately (e.g., show an error message)
    }
  };
  
  const handleSelectAll1 = (e) => {
    const check = e.target.checked;
    setSelectTipoSubs(check);
    if (check){
      setSelectedsData1(selectedData1);
      setTipoSuscripcion(selectedData1);
    }else{
      setSelectedsData1([]);
      setTipoSuscripcion([]);
    }
  }

  useEffect(() => {
    setShowLoadingData1(true)
    fetchFilter1(searchValue1)
  }, [searchValue1])

  const fetchFilter2 = async (filter = null) => {
    try {
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { query: "getMarket", name_filter: "${filter}" }) {
            key
            description_filter
            type_filter
            value_filter
            id_statement
          }
        }`
      });
  
      const data = response.data.getFiltersRedshift.sort((a, b) => a.value_filter.localeCompare(b.value_filter));;
  
      if (data[0].id_statement !== null) {
        await getValues({
          idStatement: data[0].id_statement,
          query: "getMarket",
          setter: setSelectedData2,
          showLoading: setShowLoadingData2
        });
      } else {
        const newData = data.map(item => {
          const { id_statement, ...rest } = item;
          return rest;
        });
  
        setSelectedData2(newData.length > 0 && newData[0].value_filter !== "Sin Datos" ? newData : []);
        setShowLoadingData2(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle the error appropriately (e.g., show an error message)
    }
  };

  const handleSelectAll2 = (e) => {
    const check = e.target.checked;
    setSelectMercado(check);
    if(check){
      setSelectedsData2(selectedData2);
      setMercado(selectedData2);
    }else{
      setSelectedsData2([]);
      setMercado([]);
    }
  }
  
  useEffect(() => {
    setShowLoadingData2(true)
    fetchFilter2(searchValue2)
  }, [searchValue2])


  const getValues = async ({ idStatement, query, setter, showLoading }) => {
    let response = [];
    while (response.length === 0) {
      const result = await API.graphql({
        query: `query MyQuery {
          getData(input: {id_statement: "${idStatement}", query: "${query}" }) {
            key
            description_filter
            type_filter
            value_filter
          }
        }`
      });
      response = result.data.getData;

      if (response.length === 0) {
        await new Promise(resolve => setTimeout(resolve, 5000)); // Esperar 5 segundos antes de hacer la siguiente petición
      }
    }
    setter(response.length > 0 && response[0].value_filter !== "Sin Datos" ? response : [])
    showLoading(false)
  };

  const filters = [
    {
      title: "Tipo Suscripcion",
      selectedData: selectedData1,
      setSelectedData: setSelectedData1,
      selectedsData: selectedsData1,
      setSelectedsData: setSelectedsData1,
      filterComponent: tipoSuscripcion,
      setFilterComponent: setTipoSuscripcion,
      banderaTags: banderaTags1,
      setBanderaTags: setBanderaTags1,
      showLoadingData: showLoadingData1,
      setShowLoadingData: setShowLoadingData1,
      handleSelectAll: handleSelectAll1,
      selectAll: selectTipoSubs,
    },
    {
      title: "Mercado",
      selectedData: selectedData2,
      setSelectedData: setSelectedData2,
      selectedsData: selectedsData2,
      setSelectedsData: setSelectedsData2,
      filterComponent: mercado,
      setFilterComponent: setMercado,
      banderaTags: banderaTags2,
      setBanderaTags: setBanderaTags2,
      showLoadingData: showLoadingData2,
      setShowLoadingData: setShowLoadingData2,
      handleSelectAll: handleSelectAll2,
      selectAll: selectMercado,
    }
  ]

  const {
    currentPage,
    handleNext,
    handlePrev,
    visibleItems: visibleFilters,
    endIndex,
  } = usePagination(filters);

  return (
    <Row className="DemograficosColumns" gutter={16}>
      <Col span={12}>
        <Row gutter={[16, 24]}>
          {visibleFilters.map((filter, index) => (
            <Col span={12} key={index}>
              <h3>{filter.title}</h3>
              <FiltersTable
                selectedData={filter.selectedData}
                setSelectedData={filter.setSelectedData}
                selectedsData={filter.selectedsData}
                setSelectedsData={filter.setSelectedsData}
                filterComponent={filter.filterComponent}
                setFilterComponent={filter.setFilterComponent}
                banderaTags={filter.banderaTags}
                setBanderaTags={filter.setBanderaTags}
                showLoadingData={filter.showLoadingData}
                setShowLoadingData={filter.setShowLoadingData}
              />
            </Col>
          ))}
        </Row>
        {filters.length > 2 && (
          <Row style={{ marginTop: '20px', justifyContent: 'center' }}>
            <div style={{ display: 'flex', gap: '16px' }}>
              <Button
                className="navigation-button"
                shape="circle"
                icon={<LeftOutlined />}
                onClick={handlePrev}
                disabled={currentPage === 0}
              />
              <Button
                className="navigation-button"
                shape="circle"
                icon={<RightOutlined />}
                onClick={handleNext}
                disabled={endIndex >= filters.length}
              />
            </div>
          </Row>
        )}
      </Col>
      <Col span={12} >
        <Row gutter={[16, 16]} style={{ justifyContent: 'flex-end' }}> 
          <Card
              style={{
                width: 500,
                height: 300,
                marginTop: 20,
                overflow: 'auto',
                borderRadius: 15, 
              }}
            >
            {selectedsData1 && selectedsData1.map(({ key, value_filter }) => (
              <Tag
                key={key}
                className="TagsSelectFilters"
                closable
                onClose={e => {
                  remove(selectedsData1, { key: key });
                  setSelectedsData1([...selectedsData1]);
                  setBanderaTags1(true);
                }}
              >
                {value_filter}
              </Tag>
            ))}
            {selectedsData2 && selectedsData2.map(({ key, value_filter }) => (
              <Tag
                key={key}
                className="TagsSelectFilters"
                closable
                onClose={e => {
                  remove(selectedsData2, { key: key });
                  setSelectedsData2([...selectedsData2]);
                  setBanderaTags2(true);
                }}
              >
                {value_filter}
              </Tag>
            ))}
          </Card>
        </Row>
      </Col>
    </Row>
  );
}
export default UserProfile;